<template>
  <path
    d="M1.01 7.00024L1 17.0002C1 18.1002 1.9 19.0002 3 19.0002H21C22.1 19.0002 23 18.1002 23 17.0002V7.00024C23 5.90024 22.1 5.00024 21 5.00024H3C1.9 5.00024 1.01 5.90024 1.01 7.00024ZM19 7.00024V17.0002H5V7.00024H19Z"
  />
</template>
